import BasePropertyView from 'BasePropertyView.js';
import _Template from 'properties/accessibility/description.ejs';
import undoService from 'UndoService';
import textConstants from 'TextConstants';
import listService from '../../../service/ListService';
import util from 'util/Util';

class NavAccessDescriptionView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = '#accessibilityDesc';

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        if (!this.model.get('accessDesc')) {
            this.model.set('accessDesc', '', {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        const oldVal  = this.model.get(propName);

        this.model.set( propName, propVal );

        // PF-3465 Undo/Redo for Description.
        undoService.add({
            undo: () =>{
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,oldVal,this.model,this.render.bind(this),'GroupPropertyChange')
                }
                else {
                    this.model.set( propName, oldVal );
                }
            },
            redo:() => {
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
                }
                else {
                    this.model.set( propName, propVal );
                }
            }
        },textConstants.UNDO_ACCESS_DESCRIPTION)
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if ( listService.selectedCount > 1 ) {
            setTimeout(()=>{
                $(this.$el[0]).html(this.template(this.model.toJSON()));
            },100);
        }
        
        this.addMultilanguageIcon();
        
        this.delegateEvents();
        return this;
    }

}

export default NavAccessDescriptionView;
